import { FC, ReactNode } from 'react';
import { Heading } from '@getstream/ui-library/build';

export type Props = {
  children: ReactNode | undefined;
  className?: string;
  large?: boolean;
  noGradient?: boolean;
};

export const Title: FC<Props> = ({ children, ...props }) => (
  <Heading tag="h1" className="leading-snug text-5xl" {...props}>
    {children}
  </Heading>
);
